<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-27 15:54:37
 * @LastEditTime: 2019-10-09 10:03:53
 * @LastEditors: Please set LastEditors
 -->
<template>
  <el-dialog
    :title="roleFormDialog.dialogTittle"
    :close-on-click-modal="false"
    :before-close="handleDialogClose"
    :visible.sync="dialogVisible"
    :modal="false"
    width="480px"
    class="roleFormDialog-wrapper"
  >
    <div v-if="roleFormDialog.status === 'view'" style="padding-right: 20px">
      <div
        v-for="(val, key) in roleFormDialog.currentRowData"
        :key="key"
        v-if="viewCoumns.includes(key)"
        class="view-item"
        style="padding-left:20px;"
      >
        <span>{{ lableArray[key] }}</span>
        <span v-if="key === 'roleType'">{{ dealRoleTypeData(val) }}</span>
        <!-- <span v-else-if="key === 'menus'">
          <el-tag
            v-for="(item, index) in stringToArray(val)"
            :key="index"
            :type="index % 2 === 0 ? 'primary' : 'success'"
            close-transition
            >{{ item }}</el-tag
          >
        </span> -->
        <span v-if="!['menus', 'roleType'].includes(key)">{{ val }}</span>
      </div>
    </div>
    <div v-if="roleFormDialog.status !== 'view'" style="padding-right: 20px">
      <el-form
        :model="roleFormData"
        status-icon
        :rules="rules"
        ref="roleFormData"
        :label-width="labelWidth"
        class="demo-ruleForm"
      >
        <el-form-item :label="lableArray.roleName" prop="roleName">
          <el-input
            type="text"
            v-model="roleFormData.roleName"
            auto-complete
            required
            :disabled="roleFormDialog.status === 'view' ? true : false"
          ></el-input>
        </el-form-item>
        <el-form-item :label="lableArray.roleCode" prop="roleCode">
          <el-input
            type="text"
            v-model="roleFormData.roleCode"
            auto-complete
            required
            :disabled="roleFormDialog.status === 'view' ? true : false"
          ></el-input>
        </el-form-item>
        <el-form-item :label="lableArray.roleType" prop="roleType">
          <el-select
            v-model="roleFormData.roleType"
            clearable
            style="width: 100%"
            placeholder="请选择角色类型"
            :disabled="roleFormDialog.status === 'view' ? true : false"
          >
            <el-option
              v-for="(item, mark) in roleTypeData"
              :key="mark"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="lableArray.roleDesc" prop="roleDesc">
          <el-input
            type="text"
            v-model="roleFormData.roleDesc"
            auto-complete
            :disabled="roleFormDialog.status === 'view' ? true : false"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item :label="lableArray.defaultPage">
          <el-col :span="19" style="margin-right: 10px">
            <el-input
              type="text"
              v-model="roleFormData.defaultPage"
              auto-complete
              :disabled="true"
              placeholder="点击右侧按钮选择默认首页"
            ></el-input>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-button
              @click="selectDefaultPage"
              icon="el-icon-menu"
            ></el-button>
          </el-col>
        </el-form-item> -->
      </el-form>
    </div>
    <span
      v-if="roleFormDialog.status !== 'view'"
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        :disabled="disabled"
        @click="submit('roleFormData')"
        >确 认</el-button
      >
      <el-button @click="closeDialog">关 闭</el-button>
    </span>
    <span
      v-if="roleFormDialog.status === 'view'"
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeDialog">关 闭</el-button>
    </span>
    <!-- 选择默认页start -->
    <selectDefaultPage />
    <!-- 选择默认页end -->
  </el-dialog>
</template>
<script>
import { addRole } from "@/api/system/role";
import { dealRoleType, dealRoleTypeData, stringToArray } from "@/util/utils";
import { mapGetters, mapMutations } from "vuex";
import selectDefaultPage from "@/components/dialog/roleManage/selectDefaultPage.vue";

export default {
  name: "roleFormDialog",
  data() {
    var validateText = (rule, value, callback) => {
      if (!value && value !== 0) {
        switch (rule.field) {
          case 'roleName':
            callback(new Error("角色名称不能为空"))
            break;
          case 'roleCode':
            callback(new Error("角色标识不能为空"))
            break;
          default:
            callback(new Error("不能为空"))
            break;
        }
      } else if (value.length > 50) {
        switch (rule.field) {
          case 'roleName':
            callback(new Error("角色名称输入过长"))
            break;
          case 'roleCode':
            callback(new Error("角色标识输入过长"))
            break;
          default:
            callback(new Error("输入过长"))
            break;
        }
      } else {
        callback();
      }
    };
    return {
      labelWidth: "100px",
      viewCoumns: ["roleName", "roleCode", "roleType", "roleDesc", "menus"],
      lableArray: {
        roleName: "角色名称:",
        roleCode: "角色标识:",
        roleType: "角色类型:",
        roleDesc: "角色描述:",
        defaultPage: "默认页:"
        // menus: "权限:"
      },
      rules: {
        roleName: [{ required: true, validator: validateText, trigger: "blur" }],
        roleCode: [{ required: true, validator: validateText, trigger: "blur" }],
        roleType: [{ required: true, validator: validateText, trigger: "blur" }],
      },
      dealRoleType: dealRoleType,
      dealRoleTypeData: dealRoleTypeData,
      stringToArray: stringToArray,
      disabled: false
    };
  },
  components: { selectDefaultPage },
  computed: {
    ...mapGetters([
      "roleFormData",
      "roleFormDialog",
      "dialogVisible",
      "roleTypeData"
    ])
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.disabled = false;
        this.$refs.roleFormData && this.$refs.roleFormData.clearValidate();
      }
    }
  },
  created() {
    console.log(this.roleFormData)
  },
  methods: {
    ...mapMutations({
      setDialogVisible: "setDialogVisible",
      setDefaultPageDialog: "setDefaultPageDialog"
    }),
    closeDialog() {
      this.setDialogVisible(false);
    },
    handleDialogClose() {
      this.setDialogVisible(false);
    },
    selectDefaultPage() {
      this.setDefaultPageDialog(true);
    },
    // 提交表单
    submit(formName) {
      this.$refs[formName].validate(valid => {
        // console.log("验证结果：", valid);
        if (valid) {
          this.disabled = true;
          const {
            roleId,
            roleName,
            roleCode,
            roleDesc,
            roleType,
            defaultPageId
          } = this.roleFormData;
          const query = {
            roleName,
            roleCode,
            roleDesc,
            roleType,
            // defaultPage: defaultPageId,
            dsType: 0,    // 老版内诊接口要求必传的参数,我也不知道是啥
            status: this.roleFormDialog.status
          };
          if (this.roleFormDialog.status === "edit") {
            Object.assign(query, { roleId });
          }
          addRole(query)
            .then(res => {
              console.log("提交表单结果：", res);
              if (res.data.code == 0) {
                this.setDialogVisible(false);
                this.$parent.getTableData();
                this.$message.closeAll();
                this.$message.success("恭喜你，操作成功");
              }
            })
            .catch(err => {
              console.log("err:", err);
              this.disabled = false;
              this.$message.closeAll();
              this.$message.error("操作失败");
            });
        } else {
          this.disabled = false;
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less">
.roleFormDialog-wrapper {
  .el-input {
    .el-input__inner {
      padding: 0 30px 0 15px;
    }
  }
}
</style>
